import { render, staticRenderFns } from "./Components.vue?vue&type=template&id=72963f40&"
import script from "./Components.vue?vue&type=script&lang=js&"
export * from "./Components.vue?vue&type=script&lang=js&"
import style0 from "./Components.vue?vue&type=style&index=0&id=72963f40&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports